export const SETTINGS_KEY = 'parameterChart';

export const DEFAULT_TRACK_SETTINGS = {
  name: 'New Track',
  traces: [],
};

export const DEFAULT_TRACE_SETTINGS = {
  traceType: 'line',
  dashStyle: 'Solid',
  lineColor: '#ccc',
  lineWidth: 1,
  autoScale: true,
};

export const MAX_TRACE_COUNT = 10;
